import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetChangeBranchPostFix = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const getBranchPostFix = (
    guid,
    setPathfixValue,
    // eslint-disable-next-line max-params
  ) => {
    axiosClient
      .get(`Product/Branch/ChangePostFix?guid=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setPathfixValue(res.data?.value);
        } else {
          enqueueSnackbar(res?.data?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getBranchPostFix, loading];
};

export default useGetChangeBranchPostFix;
